<template>
  <Component
    :is="tag"
    class="nav-item"
    :class="{ 'nav-item--with-dropdown': item.items?.length }"
    @mouseenter="handleHoverDropdown"
    @mouseleave="handleHoverEndDropdown"
  >
    <BaseLink
      v-if="item.link"
      :link="item.link"
      class="lnk t-menu-1 focus-visible"
    >
      {{ item.label }}
    </BaseLink>
    <template v-else>
      <button
        class="lnk t-menu-1 focus-visible"
        :class="{ 'language-switcher': isLanguageSwitcher(item) }"
        @click="handleLinkClick"
      >
        {{ item.label }}
      </button>
      <NavigationDropdown
        v-if="item.items?.length"
        :item="item"
        class="dropdown"
      >
        <template #default="{ subItem }">
          <NavigationSubItem
            class="focus-visible"
            :item="subItem"
            @click="handleLinkClick"
          />
        </template>
      </NavigationDropdown>
    </template>
  </Component>
</template>

<script setup lang="ts">
import type { PublicMenuItem } from '@/service/__generated-api'

const props = withDefaults(
  defineProps<{ tag?: 'li' | 'div'; item: PublicMenuItem }>(),
  {
    tag: 'li'
  }
)

const isLanguageSwitcher = (
  item: PublicMenuItem & { type?: 'language-switcher' }
): boolean => item?.type === 'language-switcher'

const handleHoverDropdown = () => {
  if (!props.item.link && props.item.items?.length) {
    document
      .querySelector('main.main-content')
      ?.classList.add('main-content--blurred')
  }
}

const handleHoverEndDropdown = () => {
  document
    .querySelector('main.main-content')
    ?.classList.remove('main-content--blurred')
}

const handleLinkClick = () => {
  if (document.activeElement instanceof HTMLElement)
    document.activeElement.blur()
}
</script>

<style lang="scss">
.route-change .nav-item--with-dropdown,
.route-change .nav-item--with-dropdown:hover .dropdown,
.hidden-header .nav-item--with-dropdown,
.hidden-header .nav-item--with-dropdown:hover .dropdown {
  pointer-events: none !important;
}
</style>

<style lang="scss" scoped>
.lnk {
  display: block;
  padding: rem(14.5px) rem(14px - 3px);
  white-space: nowrap;

  :first-child > & {
    padding-inline: rem(14px) rem(14px - 3px);
  }
}

.dropdown {
  pointer-events: none;
  visibility: hidden;
  opacity: 0;
  transition: all $transition;
}

.nav-item {
  position: relative;

  &:hover,
  &:focus-within {
    .dropdown {
      pointer-events: all;
      visibility: visible;
      opacity: 1;
    }
  }
}

.language-switcher {
  display: flex;
  gap: rem(8px);
  align-items: center;

  padding: rem(13.5px) rem(20px) rem(13.5px) rem(18px);
  text-transform: uppercase;
  border: 1px solid $layout-divider;
  border-radius: $border-radius-big;

  // triangle
  &::after {
    width: 0;
    height: 0;
    content: '';
    border-color: transparent transparent $global-grey-03;
    border-style: solid;
    border-width: 0 rem(4.5px) rem(5px);
    transform: rotate(180deg);
  }
}
</style>
